import "../../../FhDropdownSection.css";
import { provide, computed, openBlock, createElementBlock, createVNode, withCtx, renderSlot, createCommentVNode, createBlock, resolveDynamicComponent } from "vue";
import { DROPDOWN_SECTION_TYPE } from "./constants.mjs";
import FhRadioGroup from "../../Forms/FhRadioGroup/FhRadioGroup.mjs";
import FhCheckboxGroup from "../../Forms/FhCheckboxGroup/FhCheckboxGroup.mjs";
import FhText from "../../FhText/FhText.mjs";
import { ForcedStandaloneKey } from "../../Forms/Symbols.mjs";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = {
  key: 0,
  class: "fh-dropdown-section-header"
};
const _hoisted_2 = { key: 2 };
const _sfc_main = {
  __name: "FhDropdownSection",
  props: {
    name: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "",
      validator: (value) => ["", ...Object.values(DROPDOWN_SECTION_TYPE)].includes(value)
    },
    modelValue: {
      type: [Array, String, Number],
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    provide(ForcedStandaloneKey, true);
    const computedModelValue = computed({
      get() {
        return props.modelValue;
      },
      set(newValue) {
        emit("update:modelValue", newValue);
      }
    });
    const computedTypeComponent = computed(() => {
      switch (props.type) {
        case DROPDOWN_SECTION_TYPE.SINGLE_SELECT:
          return FhRadioGroup;
        case DROPDOWN_SECTION_TYPE.MULTI_SELECT:
          return FhCheckboxGroup;
        default:
          return null;
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", null, [
        _ctx.$slots.header ? (openBlock(), createElementBlock("span", _hoisted_1, [
          createVNode(FhText, {
            tag: "span",
            variant: "body-md",
            role: "heading",
            weight: "medium"
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "header", {}, void 0, true)
            ]),
            _: 3
          })
        ])) : createCommentVNode("", true),
        computedTypeComponent.value ? (openBlock(), createBlock(resolveDynamicComponent(computedTypeComponent.value), {
          key: 1,
          modelValue: computedModelValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => computedModelValue.value = $event),
          name: props.name
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ]),
          _: 3
        }, 8, ["modelValue", "name"])) : (openBlock(), createElementBlock("ul", _hoisted_2, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]))
      ]);
    };
  }
};
const FhDropdownSection = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-ffa9064d"]]);
export {
  FhDropdownSection as default
};
//# sourceMappingURL=FhDropdownSection.mjs.map
